<template>
  <v-container
    fluid
    grid-list-xl
  >
    <div v-if="statsLoading && isDashboardEmpty" class="dashboard-throbber">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>
    <div v-else-if="statsLoading" class="dashboard-spinner-top">
      <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
    </div>

    <v-card class="pa-4 rounded-lg">
      <v-layout row class="d-flex justify-space-between">
        <v-flex
          sm8
          xs12
          md3
          lg2
        >
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="40"
            :return-value.sync="dateFrom"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFromFormatted"
              label="Start Date"
              prepend-icon="mdi-calendar"
              readonly
            />
            <v-date-picker
              v-model="dateFrom"
              no-title
              @input="$refs.menu1.save(dateFrom)"
              min="2020-01-01"/>
          </v-menu>
        </v-flex>

        <v-flex
          sm8
          xs12
          md3
          lg2
        >
          <v-menu
            ref="menu2"
            :close-on-content-click="false"
            v-model="menu2"
            :nudge-right="40"
            :return-value.sync="dateTo"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateToFormatted"
              label="End Date"
              prepend-icon="mdi-calendar"
              readonly
            />
            <v-date-picker
                v-model="dateTo"
                no-title
                @input="$refs.menu2.save(dateTo)"
                min="2020-01-01"/>
          </v-menu>
        </v-flex>

        <v-flex 
          v-if="loginType == 'client'"
          sm8
          xs12
          md3
          lg2
          >
          <v-select
            :items="this.$store.state.stateList"
            v-model="stateFilter"
            label="State" />
        </v-flex>

        <v-flex 
          v-if="loginType == 'client'"
          sm8
          xs12
          md3
          lg2
        >
          <v-select
            :items="this.$store.state.workOrders"
            v-model="workOrderFilter"
            label="Work Order"
            item-text="displayText"
            item-value="value"
            class="work-order-select"
            :menu-props="{ contentClass: 'custom-work-order-dropdown' }"
          >
            <template v-slot:item="{ item }">
              {{ item.displayText }}
            </template>
            <template v-slot:selection="{ item }">
              <span class="work-order-selected-text">{{ item.displayText }}</span>
            </template>
          </v-select>
        </v-flex>
        
        <v-flex 
          v-if="loginType == 'client' && agencyView == '1'"
          sm8
          xs12
          md3
          lg2
          >
          <v-select
            :items="this.$store.state.agenciesList" 
            v-model="agencyFilter"
            label="Agency"
            item-text="name" 
            item-value="name" 
          />
        </v-flex>

        <v-flex 
          v-if="loginType == 'client' && distributorView == '1'"
          sm8
          xs12
          md3
          lg2
        >
          <v-select
            :items="this.$store.state.distributorsList"
            v-model="distributorFilter"
            label="Distributor"
            item-text="name"
            item-value="name"
          />
        </v-flex>

        <v-flex 
          v-if="loginType == 'client'"
          sm8
          xs12
          md3
          lg2
        >
          <v-select
            :items="this.$store.state.brandsList"
            v-model="brandFilter"
            label="Brand"
            item-text="name"
            item-value="name"
          />
        </v-flex>

        <v-flex 
          v-if="loginType == 'client'"
          sm8
          xs12
          md3
          lg2
        >
          <v-select
            :items="this.$store.state.storeTypes"
            v-model="storeFilter"
            label="Retailer" />
        </v-flex>

        <v-flex 
          sm8
          xs12
          md3
          lg2
          v-if="loginType == 'retail'"
        >
          <v-select
            :items="this.$store.state.stateList"
            v-model="stateFilter"
            label="State" />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex sm6 xs12 md6 lg4>
          <div style="position: relative;">
            <material-stats-card
              :value="Number(this.$store.state.statistics.demos).toLocaleString()"
              color="royal"
              icon="mdi-glass-wine"
              title="Sampling Events"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Total number of product sampling events conducted</span>
            </v-tooltip>
          </div>
        </v-flex>

        <v-flex
          sm6
          xs12
          md6
          lg4
        >
          <div style="position: relative;">
            <material-stats-card
              :value="Number(this.$store.state.statistics.bottles).toLocaleString()"
              color="royal"
              icon="mdi-bottle-wine"
              title="Units Sold"
              small-value="Units"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Total retail units sold across all events</span>
            </v-tooltip>
          </div>
        </v-flex>

        <v-flex
          sm6
          xs12
          md6
          lg4
        >
          <div style="position: relative;">
            <material-stats-card
              :value="Number(this.$store.state.statistics.customers).toLocaleString()"
              color="royal"
              icon="mdi-account-group"
              title="Shoppers Engaged"
              />
             <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Number of unique shoppers who interacted with sampling events</span>
            </v-tooltip>
          </div>
        </v-flex>

        <v-flex
          sm6
          xs12
          md6
          lg4
        >
          <div style="position: relative;">
            <material-stats-card
              :value="'$' + Number(this.$store.state.statistics.sales).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              color="royal"
              icon="mdi-currency-usd"
              title="Total Sales"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Gross revenue, calculated as the cost of the product multiplied by the number of units/packs sold</span>
            </v-tooltip>
          </div>
        </v-flex>

        <v-flex
          v-show = "hasPacks"
          sm6
          xs12
          md6
          lg4
        >
          <div style="position: relative;">
            <material-stats-card
              :value="Number(this.$store.state.statistics.packs).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              color="royal"
              icon="mdi-package-variant"
              title="Packs Sold"
              small-value="Units"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Number of multi-unit packs sold</span>
            </v-tooltip>
          </div>
        </v-flex>

        <v-flex
          sm6
          xs12
          md6
          lg4
        >
          <div style="position: relative;">
            <material-stats-card
              :value="(isNaN(parseInt(this.$store.state.statistics.samples)))?'':Number(this.$store.state.statistics.samples).toLocaleString()"
              color="royal"
              icon="mdi-cup-water"
              title="Samples Given"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Total number of product samples distributed to consumers</span>
            </v-tooltip>
          </div>
        </v-flex>
        
        <v-flex
            sm6
            xs12
            md6
            lg4
        >
          <div style="position: relative;">
            <material-stats-card
                :value="(this.$store.state.statistics.demos == 0)?'0':(Number(this.$store.state.statistics.stocked / this.$store.state.statistics.demos * 100).toFixed(0))"
                color="royal"
                icon="mdi-clipboard-check"
                title="Adequate Stock"
                small-value="%"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Percentage of retail locations with at least 4 units/packs at the start of the event</span>
            </v-tooltip>
          </div>
        </v-flex>

        <v-flex
          v-if="loginType=='client'"
          sm6
          xs12
          md6
          lg4
        >
          <div style="position: relative;">
            <material-stats-card
              :value="Number(this.$store.state.statistics.impressions).toLocaleString()"
              color="royal"
              icon="mdi-eye"
              title="Impressions"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Number of unique users who saw a digital ad for a sampling event (capped at 36 months)</span>
            </v-tooltip>
          </div>
        </v-flex>

        <v-flex 
          v-if="loginType=='client'"
          sm6
          xs12
          md6
          lg4
        >
          <div style="position: relative;">
            <material-stats-card
              :value="this.$store.state.statistics.acquisition_cost == null ? 'N/A' : '$' + Number(this.$store.state.statistics.acquisition_cost).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              color="royal"
              icon="mdi-account-check"
              title="Customer Acquisition Cost"
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  small
                  style="position: absolute; top: 1px; right: 1px"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Average cost to acquire each new customer, calculated as (Total Billed - Total Sales × 1.5) / Samples Given</span>
            </v-tooltip>
          </div>
        </v-flex>
        
      </v-layout>

    </v-card>

    <v-layout column>
 
      <v-flex
        v-if="loginType == 'client'"
        md12
        lg6
      >
        <material-card
          color="secondary"
        >
            <template slot="header">
              <!-- Flex container for header -->
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <div>
                  <h4 class="title font-weight-light mb-2">Top SKUs</h4>
                  <p class="category font-weight-thin">Top products sold this period</p>
                </div>
                <v-btn
                  :loading="csvExporting"
                  :disabled="csvExporting"
                  flat
                  large
                  @click.native="exportCSV"
                >
                  <v-icon large color="white">mdi-cloud-download</v-icon> &nbsp;.csv
                </v-btn>
              </div>
            </template>
          <v-data-table
            :headers="headers"
            :items="this.$store.state.sales.sales"
            disable-initial-sort
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{item }"
            >
              <td>{{ item.name }}</td>
              <td class="text-xs-right">{{ Number(item.bottles_sold).toLocaleString() }}</td>
              <td class="text-xs-right">{{ (item.bottles_per_unit == '1') ? 'N/A' : Number(item.packs_sold).toLocaleString() }}</td>
              <td class="text-xs-right">{{ (isNaN(parseInt(item.total_samples)))?'':Number(item.total_samples).toLocaleString() }}</td>
              <td class="text-xs-right">${{ parseFloat(item.avg_price).toFixed(2) }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex
        v-if="loginType == 'client'"
        md12
        lg6
      >
        <material-card
          color="secondary"
          title="Top Retailers"
          text="Top retailers hosting Events"
        >
          <v-data-table
            :headers="headers2"
            :items="this.$store.state.storeSales"
            disable-initial-sort
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{item }"
            >
              <td>{{ item.store_type }}</td>
              <td class="text-xs-right">{{ item.demos }}</td>
              <td class="text-xs-right">{{ Number(item.bottles_sold).toLocaleString() }}</td>
              <td class="text-xs-right">{{ (item.bottles_per_unit == '1') ? 'N/A' : Number(item.packs_sold).toLocaleString() }}</td>
              <td class="text-xs-right">{{ (isNaN(parseInt(item.total_samples)))?'': Number(item.total_samples).toLocaleString() }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex
        v-if="loginType == 'retail'"
        md12
        lg6
      >
        <material-card
          color="secondary"
          title="Top Stores"
          text="Top hosting locations"
        >
          <v-data-table
            :headers="headers4"
            :items="this.$store.state.retailStoreSales"
            disable-initial-sort
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{item }"
            >
              <td>{{ item.store }}</td>
              <td class="text-xs-right">{{ item.demos }}</td>
              <td class="text-xs-right">{{ parseInt(item.customers).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              <td class="text-xs-right">{{ parseInt(item.bottles).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              <td class="text-xs-right">{{ (isNaN(parseInt(item.samples)))?'':parseInt(item.samples).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex
        v-if="loginType == 'retail'"
        md12
        lg6
      >
        <material-card
          color="secondary"
          title="Top Suppliers"
          text="Top Suppliers sponsoring Events"
        >
          <v-data-table
            :headers="headers3"
            :items="this.$store.state.supplierSales.suppliers"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            disable-initial-sort
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{item }"
            >
              <td>{{ item.client_name }}</td>
              <td class="text-xs-right">{{ item.demos }}</td>
              <td class="text-xs-right">{{ parseInt(item.locations).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              <td class="text-xs-right">{{ item.bottles.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
              <td class="text-xs-right">{{ (item.bottles_per_unit > 1) ? item.packs_sold.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 'N/A' }}</td>
              <td class="text-xs-right">{{ (isNaN(parseInt(item.samples)))?'':parseInt(item.samples).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex
        v-if="loginType == 'client' && agencyView == '1'"
        md12
        lg6
      >
        <material-card
          color="secondary"
          title="Top Agencies"
          text="Click on an agency to view events"
        >
          <v-data-table
            :headers="headers_agencies"
            :items="this.$store.state.agencies"
            disable-initial-sort
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <tr @click="navigateToRecapsWithAgencyFilter(props.item)" style="cursor: pointer;">
                <td class="text-xs-left">{{ props.item.agency_name }}</td>
                <td class="text-xs-right">{{ Number(props.item.events).toLocaleString() }}</td>
                <td class="text-xs-right">{{ Number(props.item.locations).toLocaleString() }}</td>
                <td class="text-xs-right">{{ parseInt(props.item.bottles_sold).toLocaleString() }}</td>
                <td class="text-xs-right">{{ (props.item.bottles_per_unit == '1') ? 'N/A' : Number(props.item.packs_sold).toLocaleString() }}</td>
                <td class="text-xs-right">{{ isNaN(parseInt(props.item.total_samples)) ? '' : parseInt(props.item.total_samples).toLocaleString() }}</td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { TokenService } from '../services/storage.service'
export default {
  data () {
    return {
      menu2: false,
      menu1: false,
      statsLoading: false,
      rowsPerPageItems: [10, 30, 50, 100],
      csvExporting: false,
      pagination: {
        rowsPerPage: 10
      },
      dailySalesChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [
            [12, 17, 7, 17, 23, 18, 38]
          ]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      dataCompletedTasksChart: {
        data: {
          labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
          series: [
            [230, 750, 450, 300, 280, 240, 200, 190]
          ]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      emailsSubscriptionChart: {
        data: {
          labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]

          ]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0]
              }
            }
          }]
        ]
      },
      headers: [

        {
          sortable: true,
          text: 'Name',
          value: 'name',
          width: '35%'
        },
        {
          sortable: true,
          text: 'Units Sold',
          value: 'bottles_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Packs Sold',
          value: 'packs_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Samples',
          value: 'total_samples',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Avg Price',
          value: 'avg_price',
          align: 'right'
        }

      ],
      headers_nopack: [
      {
          sortable: true,
          text: 'Name',
          value: 'name'
        },
        {
          sortable: true,
          text: 'Units Sold',
          value: 'bottles_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Samples',
          value: 'total_samples',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Avg Price',
          value: 'avg_price',
          align: 'right'
        }
      ],
      headers2: [
        {
          sortable: true,
          text: 'Name',
          value: 'store_type'
        },
        {
          sortable: true,
          text: 'Events',
          value: 'demos',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Units Sold',
          value: 'bottles_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Packs Sold',
          value: 'packs_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Samples',
          value: 'total_samples',
          align: 'right'
        }

      ],
      headers3: [
        {
          sortable: true,
          text: 'Supplier',
          value: 'client_name'
        },
        {
          sortable: true,
          text: 'Events',
          value: 'demos',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Locations',
          value: 'locations',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Units Sold',
          value: 'bottles',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Packs Sold',
          value: 'packs_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Samples',
          value: 'samples',
          align: 'right'
        }

      ],
      headers4: [
        {
          sortable: true,
          text: 'Store Name',
          value: 'store',
          width: '35%'
        },
        {
          sortable: true,
          text: 'Events',
          value: 'demos',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Customers',
          value: 'customers',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Units Sold',
          value: 'bottles',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Samples',
          value: 'samples',
          align: 'right'
        }

      ],
      headers_agencies: [
        {
          sortable: true,
          text: 'Agency',
          value: 'agency_name'
        },
        {
          sortable: true,
          text: 'Events',
          value: 'events',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Locations',
          value: 'locations',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Units Sold',
          value: 'bottles_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Packs Sold',
          value: 'packs_sold',
          align: 'right'
        },
        {
          sortable: true,
          text: 'Samples',
          value: 'total_samples',
          align: 'right'
        }
      ],
      items: [
        {
          name: 'Benziger Chardonnay',
          units: '150'
        },
        {
          name: 'Benziger Sauvignon Blanc',
          units: '52'
        }, {
          name: 'Benziger Cabernet Sauvignon',
          units: '10'
        }, {
          name: 'Cupcake Chardonnay',
          units: '7'
        }
      ],
      items2: [
        {
          name: 'HEB',
          demos: '30'
        },
        {
          name: 'Safeway',
          demos: '15'
        }, {
          name: 'Twin Liquors',
          demos: '5'
        }, {
          name: 'Costco',
          demos: '3'
        }
      ],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false
      }
    }
  },
  computed: {
    dateFromFormatted () {
      return this.formatDate(this.dateFrom)
    },
    dateToFormatted () {
      return this.formatDate(this.dateTo)
    },
    demos () {
      return '' + this.$store.state.statistics.demos
    },
    authenticated () {
      return this.$store.state.accessKey != null && this.$store.state.authenticating == false
    },
    stateFilter: {
      get () {
        return this.$store.state.stateFilter
      },
      set (value) {
        this.$store.commit('setStateFilter', value)
      }
    },
    workOrderFilter: {
      get () {
        return this.$store.state.workOrderFilter
      },
      set (value) {
        this.$store.commit('setWorkOrderFilter', value)
      }
    },
    dateFrom: {
      get () {
        return this.$store.state.dateFrom
      },
      set (value) {
        this.$store.commit('setDateFrom', value)
      }
    },

    dateTo: {
      get () {
        return this.$store.state.dateTo
      },
      set (value) {
        this.$store.commit('setDateTo', value)
      }
    },

    loginType () {
      return this.$store.state.login_type
    },

    agencyView () {
      return this.$store.state.agencyView
    },

    distributorView () {
      return this.$store.state.distributorView
    },

    hasPacks () {
      return (Number(this.$store.state.statistics.packs) < Number(this.$store.state.statistics.bottles/1.5) ? true : false)
    },

    packsSold () {
      this.getPacksSold()
    },

    agencyFilter: {
      get () {
        return this.$store.state.agencyFilter
      },
      set (value) {
        this.$store.commit('setAgencyFilter', value)
      }
    },

    distributorFilter: {
      get () {
        return this.$store.state.distributorFilter
      },
      set (value) {
        this.$store.commit('setDistributorFilter', value)
      }
    },

    brandFilter: {
      get () {
        return this.$store.state.brandFilter
      },
      set (value) {
        this.$store.commit('setBrandFilter', value)
      }
    },

    storeFilter: {
      get () {
        return this.$store.state.storeFilter
      },
      set (value) {
        this.$store.commit('setStoreFilter', value)
      }
    },

    isDashboardEmpty () {
      if (!this.$store.state.statistics) return true
      const values = Object.values(this.$store.state.statistics) 
      return values.every(val => !val || val === 0)
    },
  },

  watch: {
    // Update stats and states when dateFrom changes
    dateFrom (val) {
      if (this.dateTo != null) {
        this.getStats()
        this.$store.dispatch('get_states', { dateStart: this.dateFrom, dateEnd: this.dateTo })
      }
    },
    // Update stats and states when dateTo changes
    dateTo (val) {
      if (this.dateFrom != null) {
        this.getStats()
        this.$store.dispatch('get_states', { dateStart: this.dateFrom, dateEnd: this.dateTo })
      }
    },
    authenticated (val) {
      if (this.authenticated) {
        this.getStats()
      }
    },
    stateFilter (val) {
      this.getStats()
    },

    workOrderFilter (val) {
      this.getStats()
    },

    agencyFilter (val) {
      this.getStats()
    },

    distributorFilter (val) {
      this.getStats()
    },

    brandFilter (val) {
      this.getStats()
    },

    storeFilter (val) {
      this.getStats()
    },

    agencyView (val) {
      this.$forceUpdate()
    },
  },

  created: function () {
    if (this.authenticated) this.getStats()
  },

  methods: {

    exportCSV () {
      this.csvExporting = true
      var context = this
      console.log('start download file')

      var state_param = ''
      if (this.$store.state.stateFilter != 'All') {
        state_param = '&state=' + this.$store.state.stateFilter
      }

      var store_param = ''
      if (this.$store.state.storeFilter != 'All') {
        store_param = '&store_type=' + this.$store.state.storeFilter
      }

      var agency_param = ''
      if (this.$store.state.agencyFilter != 'All') {
        agency_param = '&agency=' + this.$store.state.agencyFilter
      }

      var login_type = ''
        if (this.$store.state.login_type == 'client') {
           login_type = "clients/"
        } else {
          login_type = "retail/"
        }

      var distributor_param = ''
      if (this.$store.state.distributorFilter != 'All') {
        console.log(distributor_param)
        distributor_param = '&distributor=' + this.$store.state.distributorFilter
      }

      var brand_param = ''
      if (this.$store.state.brandFilter != 'All') {
        brand_param = '&brand=' + this.$store.state.brandFilter
      }

      var url = this.$store.state.apiRoot + login_type + TokenService.getLoginCode() + '/sales?access_key=' + TokenService.getAccessKey() + '&filetype=csv' + '&date_start=' + this.$store.state.dateFrom + '&date_end=' + this.$store.state.dateTo + state_param + store_param + agency_param + distributor_param + brand_param
      window.location.href = url

      setTimeout(function () {
        console.log('finish download file')
        context.csvExporting = false
      }, 3500)
    },

    getStats () {
      // statsLoading state is used to display the throbber while waiting for a response from the KPI request, get_stats()
      this.statsLoading = true
      this.$store.dispatch('get_stats', 
        {dateStart: this.dateFrom, 
        dateEnd: this.dateTo, 
        state: this.stateFilter, 
        workOrder: this.workOrderFilter, 
        agency: this.agencyFilter, 
        distributor: this.distributorFilter, 
        brand: this.brandFilter, 
        storeType: this.storeFilter})
        .then(() => {
          this.statsLoading = false
        })

        
      if (this.$store.state.login_type == 'client') {
        this.$store.dispatch('get_storeTypes', { dateStart: this.dateFrom, dateEnd: this.dateTo })
        this.$store.dispatch('get_workOrders')
        this.$store.dispatch('get_sales', {dateStart: this.dateFrom, dateEnd: this.dateTo, state: this.stateFilter, workOrder: this.workOrderFilter, agency: this.agencyFilter, distributor: this.distributorFilter, brand: this.brandFilter, storeType: this.storeFilter})
        this.$store.dispatch('get_topAgencies', {dateStart: this.dateFrom, dateEnd: this.dateTo, state: this.stateFilter, workOrder: this.workOrderFilter})
        this.$store.dispatch('get_storeSales', {dateStart: this.dateFrom, dateEnd: this.dateTo, state: this.stateFilter, workOrder: this.workOrderFilter, agency: this.agencyFilter, distributor: this.distributorFilter, brand: this.brandFilter, storeType: this.storeFilter})
        this.$store.dispatch('get_agencies') 
        if (!this.$store.state.distributorsList || this.$store.state.distributorsList.length === 0) { this.$store.dispatch('get_distributors') }
        if (!this.$store.state.brandsList || this.$store.state.brandsList.length === 0) { this.$store.dispatch('get_brands') }
      } else {
        this.$store.dispatch('get_supplierSales', {dateStart: this.dateFrom, dateEnd: this.dateTo, state: this.stateFilter})
        this.$store.dispatch('get_retailStoreSales', {dateStart: this.dateFrom, dateEnd: this.dateTo, state: this.stateFilter})
      }
    },

    complete (index) {
      this.list[index] = !this.list[index]
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getPacksSold: function(){
      var packs_sold = 0
      if(this.$store.state.supplierSales.supplier){
        this.$store.state.supplierSales.supplier.forEach(demo => {
          (demo.bottles_per_unit > 1) ? packs_sold++ : 0
        })
      }
      return packs_sold
    },
    
    navigateToRecapsWithAgencyFilter(item) {
      this.$store.commit('setAgencyFilter', item.agency_name)
      this.$router.push({ name: 'Recaps' })
    }
  }

}
</script>

<style lang="scss">
.work-order-select {
  .v-select__selections {
    overflow: hidden;
    white-space: nowrap;
  }

  .work-order-selected-text {
    display: block; 
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; 
  }
}

.v-menu__content.custom-work-order-dropdown {
  min-width: auto !important;
  width: max-content !important;
}

.dashboard-throbber {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(255,255,255,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.dashboard-spinner-top {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: none;
}
</style>
